export default {
    root: {
        gap: '0.5rem'
    },
    input: {
        width: '3rem',
        sm: {
            width: '2.5rem'
        },
        lg: {
            width: '3.5rem'
        }
    }
};
